export default __webpack_public_path__ + "static/GT-America-Standard-Regular-5c7918d1fa487bce82226df1613dcf03.ttf";